import ROUTE from './routeConstants';

export const NOTIFICATION_TARGET_TRANSACTION_TYPE = 'iot';
export const TYRE_RETREAD_NOTIFICATION_EVENT = 'tyre.retread_distance';
export const TYRE_REPORT_NOTIFICATION_EVENT = 'tyre.report';

export const getNotificationQueryParams = ({
  searchText,
  siteFilter,
  statusFilter,
  readFilter,
  targetModel,
  eventType
}) => {
  const params = {};

  if (searchText?.trim()) {
    params.search = searchText.trim();
  }

  if (siteFilter && siteFilter !== 'all') {
    params.site = siteFilter;
  }

  if (eventType && eventType !== 'all') {
    params.event_type = eventType;
  } else if (targetModel && targetModel !== 'all') {
    params.target_model = targetModel;
  }

  const selectedStatus = statusFilter || readFilter;
  if (selectedStatus === 'updated') {
    params.is_updated = 'true';
  } else if (selectedStatus === 'read' || selectedStatus === 'unread') {
    params.is_read = selectedStatus === 'read' ? 'true' : 'false';
    params.is_updated = 'false';
  }

  return params;
};

export const getNotificationTargetRoute = (notification, { tyreManagementEnabled = true } = {}) => {
  const targetModel = notification?.target_model?.model?.toLowerCase();
  const objectId = notification?.target_model?.object_id;

  if (notification?.event_type === TYRE_REPORT_NOTIFICATION_EVENT) {
    if (!tyreManagementEnabled || !objectId) return null;
    return {
      pathname: ROUTE.tyreV2Reports,
      search: `?report_job=${encodeURIComponent(objectId)}`,
    };
  }

  if (notification?.event_type === TYRE_RETREAD_NOTIFICATION_EVENT) {
    if (!tyreManagementEnabled) return null;
    return {
      pathname: ROUTE.tyreV2Overview,
    };
  }

  if (!targetModel || !objectId) {
    return null;
  }

  if (targetModel === 'transaction') {
    return {
      pathname: ROUTE.transactionDetails.replace(':transactionId', objectId),
      search: `?type=${NOTIFICATION_TARGET_TRANSACTION_TYPE}`,
    };
  }

  if (targetModel === 'vehicle') {
    return {
      pathname: ROUTE.vehicleDetails.replace(':vehicleId', objectId),
    };
  }

  if (targetModel === 'card') {
    return {
      pathname: ROUTE.cardDetails.replace(':cardId', objectId),
    };
  }

  if (targetModel === 'tyrealert') {
    if (!tyreManagementEnabled) return null;
    return {
      pathname: ROUTE.tyreV2Overview,
    };
  }

  return null;
};
